import { Component, input, output } from '@angular/core'
import { Temporal } from 'temporal-polyfill'
import { AppLink } from './home-page.service'
import { AppLinkComponent } from './app-link.component'

@Component({
  selector: 'app-links-card',
  imports: [
    AppLinkComponent,
  ],
  host: {
    class: 'card',
  },
  template: `
    <div class='card-header'>{{ header() }}</div>
    <div class='card-body'>
      @if (links().length > 0) {
        <div class='links'>
          @for (link of links(); track link.path) {
            <app-link [link]="link" [now]="now()" (toggleFavorite)="toggleFavorite.emit($event)" />
          }
        </div>
      } @else if (noLinksMessage()) {
        <div class='no-links'>
          {{ noLinksMessage() }}
        </div>
      }
    </div>
  `,
  styles: `
    :host {
      width: 20rem;
      border: 1px solid #e0e0e0;
      
      .links {
        max-height: 18rem;
        min-height: 4rem;
        overflow-y: auto;
      }
      .no-links {
        opacity: 0.7
      }
    }
  `,
})
export class LinksCardComponent {
  readonly header = input.required<string>()
  readonly links = input.required<readonly AppLink[]>()
  readonly now = input.required<Temporal.Instant>()
  readonly noLinksMessage = input<string>()

  readonly toggleFavorite = output<AppLink>()
}
